var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c(
        "LoginCard",
        { attrs: { header: "Multi-Factor Authentication" } },
        [
          _c("div", { class: _vm.$style.subheader }, [
            _vm._v(
              "\n      " + _vm._s(_vm.mfaDisplayText.subheaderText) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("Alert", {
            model: {
              value: _vm.errorMessage,
              callback: function ($$v) {
                _vm.errorMessage = $$v
              },
              expression: "errorMessage",
            },
          }),
          _vm._v(" "),
          _c(
            "form",
            [
              _c(
                "LoginActionButton",
                {
                  attrs: {
                    action: _vm.handleAuth,
                    isLoading: _vm.isLoading,
                    disabled: _vm.isDisabled,
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.mfaDisplayText.buttonText) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.isWebAuthnSupported
                ? _c("span", { class: _vm.$style.unsupportedError }, [
                    _vm._v(
                      "\n        Security Keys are not supported on this browser.\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ChooseMfa",
            _vm._b(
              { attrs: { selectedFactor: _vm.factor } },
              "ChooseMfa",
              _vm.$props,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }